module.exports = __webpack_public_path__ + "double-valhalla-fr-desktop.jpg";